import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

@Component({
  selector: 'app-skeleton-match-stats',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-match-stats.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonMatchStatsComponent {
  nStats = signal(Array.from({ length: 9 }, (_, i) => i));
}
